export default "__VITE_ASSET__BWrzRP57__"